import { TooltipHost } from '@fluentui/react';
import React from 'react'
import { Card } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import CLabel from '../../../Common/CLabel';
import { TooltipOverflowMode } from '@fluentui/react/lib/Tooltip';
import { mergeStyleSets } from '@fluentui/react/lib/Styling';
import { css } from '@fluentui/react/lib/Utilities';

function RelatedConceptInfo(props) {
    const { t } = useTranslation();

    //Parametros de entrada.
    const inputParam_RelatedConceptItem = props.relatedConceptItem;

    //Parametros de componente.

    //Funciones de componente.

    //Eventos de componente.

    const classNames = mergeStyleSets({
        overflow: {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          width: 260,
        },
        parent: {
          selectors: { '> *:last-child': { marginTop: 10 } },
        },
    });

    //Render de componente.
    return (
        <Card>
            <Card.Body className="p-1">
                <div className="card-info-description">
                    <div className="d-flex">
                        <TooltipHost
                            overflowMode={TooltipOverflowMode.Self}
                            hostClassName={css(classNames.overflow)}
                            content={ inputParam_RelatedConceptItem !== null ? inputParam_RelatedConceptItem.name : "" }
                            onTooltipToggle={false}
                            styles={{
                                root: { display: 'block' },
                            }}
                        >
                            <div><b>{ `${t('data-lang-lbl-name')}: ` }</b>{ inputParam_RelatedConceptItem !== null ? inputParam_RelatedConceptItem.name : "" }</div>
                        </TooltipHost>
                        
                    </div>
                    <div className="d-flex"><CLabel labelText={ t('data-lang-lbl-code') } labelValue={ inputParam_RelatedConceptItem !== null ?
                        inputParam_RelatedConceptItem.relatedConceptCode !== undefined ? inputParam_RelatedConceptItem.relatedConceptCode : ""
                        :
                        "" } /></div>
                </div>
            </Card.Body>
        </Card>
    );
}

export default RelatedConceptInfo;